import { render, staticRenderFns } from "./SuratPermintaanKonsultasi.vue?vue&type=template&id=045f95e7&"
import script from "./SuratPermintaanKonsultasi.vue?vue&type=script&lang=js&"
export * from "./SuratPermintaanKonsultasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports